var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoResults = function SvgNoResults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 120 122"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DC2015",
    d: "M18.912 120.934v1h2v-1zm2-114.785a1 1 0 1 0-2 0zm0 114.785V6.149h-2v114.785zM99.948 120.934v1h2v-1zm2-114.785a1 1 0 1 0-2 0zm0 114.785V6.149h-2v114.785z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BE0800",
    stroke: "#BE0800",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M61.292 86.089c26.208 0 37.357-10.525 39.656-15.787V29.257c-3.364 7.367-16.006 15.837-39.656 15.837-25.173 0-41.38-9.522-41.38-15.837v41.045c2.874 5.262 15.173 15.787 41.38 15.787Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.58 53q.977 0 .916.994l-.58 12.74q-.061.995-.979.995h-2.874q-.918 0-.979-.995l-.58-12.74Q57.443 53 58.42 53zm-.184 16.282q.917 0 .917.933v3.853q0 .932-.917.932h-3.792q-.917 0-.917-.932v-3.853q0-.933.917-.933z"
  })));
};
export default SvgNoResults;